import { Component, OnInit, ViewChild } from "@angular/core";
import { PdfJsViewerComponent } from "ng2-pdfjs-viewer";
import { environment } from "@env/environment";
import { AppService } from "@app/app.service";
import { N2PdfViewerModel } from "./pdf-viewer.model";
import { BlobService } from "./blob.service";
import { PdfService } from "./pdf.service";

@Component({
  selector: "pdf-viewer",
  templateUrl: "./pdf-viewer.component.html",
})
export class PdfViewerComponent implements OnInit {
  @ViewChild(PdfJsViewerComponent, { static: false })
  pdfViewer: PdfJsViewerComponent;
  blobService = BlobService();
  params = new N2PdfViewerModel();
  env = environment;

  constructor(private appService: AppService, public pdfService: PdfService) {}

  ngOnInit() {
    this.blobService.response.subscribe((res) => {
      if (res.generateXls) {
        this.params.fileName = res.fileName;
        this.downloadFile("xlsx", res.file);
        return;
      }

      this.params = res;

      if (this.params.generateXls) {
        this.downloadFile("xlsx");
        return;
      }

      this.pdfViewer.pdfSrc = this.params.file;
      this.pdfViewer.refresh();

      setTimeout(() => {
        this.appService.blockUI = true;
      }, 10);

      localStorage.removeItem("pdfjs.history");
    });
  }

  downloadFile(extension: "pdf" | "xlsx", blob?: Blob) {
    if (!blob) blob = this.params.file;

    const downloadURL = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadURL;
    link.download = `${this.params.fileName}.${extension}`;
    link.click();
  }

  onDocumentLoad() {
    this.pdfService.displayViewer = true;
    this.appService.blockUI = false;
    this.pdfViewer.PDFViewerApplicationOptions.set("printResolution", 300);
  }

  onHide() {
    this.params = new N2PdfViewerModel();
    if (this.pdfService.onHideReport) this.pdfService.onHideReport();
  }
}
